/** Currency per Watchmode region, for the regions the API actually returns. */
const REGION_CURRENCY: Record<string, string> = {
    GB: "GBP",
    US: "USD",
    CA: "CAD",
    AU: "AUD",
    IE: "EUR",
    NZ: "NZD",
};

/**
 * Renders what a source costs.
 *
 * Watchmode gives a bare number with no currency, so the region supplies it.
 * The previous label called everything without a price "FREE with Subscription",
 * which was wrong for genuinely free services like BBC iPlayer.
 */
export function formatPrice(price: number | null | undefined, type: string, region: string): string {
    if (price) {
        const currency = REGION_CURRENCY[region];
        if (!currency) return String(price);
        try {
            return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(price);
        } catch {
            return String(price);
        }
    }

    switch (type) {
        case "free":
            return "Free";
        case "sub":
            return "Subscription";
        default:
            return "—";
    }
}
